










































































































import { Component, Vue } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import { bidTypes } from '../dictionary'
import StepsTwo from '../StepsTwo/index.vue'
import KefuQualificationDialog from '../kefuQualificationDialog/index.vue'

const timeSecond = 10

@Component({
  components: {
    StepsTwo,
    KefuQualificationDialog,
  },
})
export default class StepsOne extends Vue {
  bidTypes = bidTypes
  remainTime = timeSecond
  timer: any
  showKefuDialog: boolean = false

  @State bidType!: number
  @Mutation setBidType!: Function
  @Mutation setKefuChannel!: Function

  onCancel() {
    this.$router.push('/')
  }

  created() {
    if (this.bidType > 0) {
      this.setCountRemain()
    }
  }

  handleChangeBidType(bidType: number) {
    this.setBidType(bidType)
    this.setCountRemain()
  }

handleClickAgree() {
  this.showKefuDialog = true
}

  handleConfirm(status: number) {
    this.setKefuChannel(status)
    this.$emit('forward')
  }

  setCountRemain() {
    this.remainTime = timeSecond
    clearTimeout(this.timer)
    this.timer = null
    this.countRemain()
  }

  countRemain() {
    const context = this
    context.timer = setTimeout(() => {
      context.remainTime--
      if (this.remainTime < 1) {
        clearTimeout(context.timer)
        context.timer = null
      } else {
        this.countRemain()
      }
    }, 1000)
  }
}
